import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';
import { PredictorId } from '../PredictorId/PredictorId';
import { Shape2, Shape2Icon, Shape2Theme, Shape2Tone } from '../Shape2/Shape2';

import './PredictorHeader.css';
import * as keyset from './PredictorHeader.i18n';

export interface PredictorHeaderProps {
    isLoading?: boolean;
    detailedText: string;
    sumText: string;
    percent: number;
    error?: string;
    titleBlock?: React.ReactNode;
    hideTitle?: boolean;
    id?: string;
}

const i18n = i18nFactory(keyset);

const BLOCK = 'predictor-header';

export class PredictorHeader extends React.Component<PredictorHeaderProps> {
    render() {
        const { isLoading, percent, hideTitle } = this.props;

        return (
            <div className={BLOCK}>
                {!hideTitle && (
                    <div className={Bem.cls(BLOCK, 'title')}>
                        <span className={Bem.cls(BLOCK, 'title-text')}>{i18n('reach-title')}</span>
                        <PredictorId id={this.props.id} />
                    </div>
                )}
                {this.getTitleBlock()}
                <div className={classNames(Bem.cls(BLOCK, 'number'), TestBem.cls(BLOCK, 'number'))}>
                    {this.getInfo()}
                    <div
                        className={Bem.cls({
                            block: BLOCK,
                            elem: 'progress',
                            mods: {
                                loading: isLoading ? 'yes' : 'no'
                            }
                        })}
                    >
                        <div
                            style={{
                                width: `${isLoading ? 100 : percent}%`
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }

    private getInfo = () => {
        const { error, detailedText, sumText } = this.props;

        if (error) {
            return (
                <div className={Bem.cls(BLOCK, 'error')}>
                    <div className={Bem.cls(BLOCK, 'error-massage')}>
                        <Shape2
                            width={12}
                            height={12}
                            icon={Shape2Icon.info}
                            theme={Shape2Theme.default}
                            tone={Shape2Tone.red}
                            cls={Bem.cls(BLOCK, 'error-icon')}
                        />
                        {i18n('predictor-error')}
                    </div>
                    <div className={Bem.cls(BLOCK, 'error-value')}>—</div>
                </div>
            );
        }

        return (
            <div className={Bem.cls(BLOCK, 'value')}>
                <div className={Bem.cls(BLOCK, 'detailed')}>{detailedText}</div>
                <div className={Bem.cls(BLOCK, 'sum')}>{sumText}</div>
            </div>
        );
    };

    private getTitleBlock = () => {
        const { titleBlock } = this.props;

        if (!titleBlock) {
            return null;
        }

        return <div className={Bem.cls(BLOCK, 'title-block')}>{titleBlock}</div>;
    };
}
